export const ModernRadioButtonGroup = ({
  name,
  choices,
  selectedValue,
  onChange,
}) => (
  <div className="foundry--radio-group button--group">
    {choices.map(({ label, value }) => {
      const checked = `${value}` === `${selectedValue}`
      return (
        <div key={value} className="radio--entry">
          <input
            type="radio"
            className="radio--input"
            id={`${name}-${value}`}
            name={name}
            value={value}
            checked={checked}
            onChange={({ target }) => {
              const { value } = target
              onChange(value)
            }}
          />
          <label
            className={`radio--label foundry--button button--outlined button--modern ${
              checked && 'selected'
            }`}
            htmlFor={`${name}-${value}`}
          >
            <span className="button--label">{label}</span>
          </label>
        </div>
      )
    })}
  </div>
)
